import React from 'react';

import RecommendationStructuredView from './RecommendationStructuredView';
import { AIInsightSolution } from '../../types/recommendations';

type Props = {
  structure: AIInsightSolution;
  communityId: number;
  communityName: string;
};

const RecommendationCommunityStructured = ({ structure, communityId, communityName }: Props) => {
  return <RecommendationStructuredView structure={structure} communityId={communityId} communityName={communityName} />;
};

export default RecommendationCommunityStructured;
